import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
// Mobile detector
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className={`flex flex-col min-h-screen bg-gray-50 ${isMobile ? 'mobile-device' : ''}`} data-id="element-304">
      <Navigation data-id="element-305" />
      <main className={`flex-grow ${isMobile ? 'pt-16 pb-16' : ''}`} data-id="element-306">
        {children}
      </main>
      {!isMobile && <Footer data-id="element-307" />}
    </div>;
};
export default Layout;